import { useRequiredContext } from "@redotech/react-util/context";
import { createContext, memo, ReactNode } from "react";

interface ParcelEditContextValue {
  parcelsLength: number;
  parcelBeingEditedIndex: number;
  setParcelBeingEditedIndex: (index: number) => void;
}

const ParcelEditContext = createContext<ParcelEditContextValue | undefined>(
  undefined,
);

export const useParcelEditContext = () => useRequiredContext(ParcelEditContext);

export const ParcelEditProvider = memo(function ParcelEditProvider({
  children,
  parcelsLength,
  parcelBeingEditedIndex,
  setParcelBeingEditedIndex,
}: {
  children: ReactNode;
  parcelsLength: number;
  parcelBeingEditedIndex: number;
  setParcelBeingEditedIndex: (index: number) => void;
}) {
  return (
    <ParcelEditContext.Provider
      value={{
        parcelsLength,
        parcelBeingEditedIndex,
        setParcelBeingEditedIndex,
      }}
    >
      {children}
    </ParcelEditContext.Provider>
  );
});
